<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4 text-center">
                  <h4 class="mb-4">Zaloguj się</h4>
                  <p>Jedno konto by zarządzać wszystkimi umowami <br>i odnaleźć wszystkie klauzule.</p>
                </div>

                <div>


                  <vs-divider>Konto Google</vs-divider>

                  <div class="social-login-buttons flex flex-wrap items-center mt-4 mx-20">


                    <!-- GOOGLE -->
                    <div class="bg-google pt-3 pb-3 px-4 rounded-lg cursor-pointer mr-4 full-width d-flex"
                         @click="login">
                      <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="google"
                           class="text-white h-4 w-4 svg-inline--fa fa-google fa-w-16 m-auto" role="img"
                           xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512">
                        <path fill="currentColor"
                              d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path>
                      </svg>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </vx-card>

      <router-link :to="{name: 'landing'}"><p class="text-center mt-10">Wróć na stronę główną</p></router-link>

    </div>

  </div>
</template>

<script>
  import firebase from 'firebase/app';
  import 'firebase/auth';

  import { possibleEmails } from '../../utils/possible-emails';
  import { loadOnLogin } from '../../utils/initialiseStore';


  export default {

    methods: {
      login() {
        const provider = new firebase.auth.GoogleAuthProvider();

        firebase.auth().languageCode = 'pl';
        firebase.auth().signInWithPopup(provider).then((result) => {
          const token = result.credential.accessToken;

          if (!possibleEmails.includes(result.user.email)) {
            throw new Error('Jak śmiesz to klikać? Nie masz uprawnień nikczemniku! Tylko wybrani mogą się tu logować.')
          }

          const user = {
            uid: result.user.uid,
            displayName: result.user.displayName,
            email: result.user.email,
            photoURL: result.user.photoURL
          };

          console.log(token);
          console.log(user);
          this.$store.dispatch('updateUserInfo', { user, token }).then(() => {
            loadOnLogin().then(() => {
              this.$router.push({ name: 'panel' });
            })
          });

        }).catch((error) => {
          console.log(error);

          this.$vs.dialog({
            color: 'danger',
            title: 'Wystąpił błąd',
            text: error.message,
            acceptText: 'Ok'
          })
        });
      }
    }
  }
</script>

<style lang="scss">
  #page-login {
    .social-login-buttons {
      .bg-facebook {
        background-color: #1551b1
      }

      .bg-twitter {
        background-color: #00aaff
      }

      .bg-google {
        background-color: #4285F4;
        transition: all 0.5s;
      }

      .bg-google:hover {
        background-color: #74a7ff
      }

      .bg-github {
        background-color: #333
      }
    }
  }
</style>
